import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Section.scss';

// 1. Destructure props and set defaults in the signature
const Section = ({ 
  title = null, 
  colorScheme = 'default', 
  className = '', 
  children 
}) => {

  return (
    <section
      className={classNames(
        className,
        'edu-section',
        // 2. Direct template literal replaces the getSectionClassName helper
        `edu-section--${colorScheme}`,
        'clearfix'
      )}
    >
      {/* 3. Logical AND for cleaner title rendering */}
      {title && (
        <h2 className="edu-section__title">{title}</h2>
      )}
      
      <div className="edu-section__contents">
        {children}
      </div>
    </section>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  colorScheme: PropTypes.oneOf(['default', 'red', 'green', 'blue', 'yellow']),
  children: PropTypes.node.isRequired
};

export default Section;
